import * as he from 'he';
import {CommonUtil} from '../../common/utils/common.util';

export class Utils {

  static hexToRGBA(h, alpha) {
    let r = '0';
    let g = '0';
    let b = '0';

    // 3 digits
    if (h.length === 4) {
      r = '0x' + h[1] + h[1];
      g = '0x' + h[2] + h[2];
      b = '0x' + h[3] + h[3];

      // 6 digits
    } else if (h.length === 7) {
      r = '0x' + h[1] + h[2];
      g = '0x' + h[3] + h[4];
      b = '0x' + h[5] + h[6];
    }

    return `rgba(${+r},${+g},${+b},${alpha})`;
  }

  /**
   * A project name as a file name. The patterns here were strings, which
   * replace() matches literally, so nothing was ever removed and each browser
   * rewrote "Plot 3/4: North" its own way. The export's rule applies instead,
   * so an .mmp and the exports of one project are named alike.
   */
  static removeSpecialChars(str: string): string {
    return CommonUtil.removeSpecialChars(str);
  }

  static map(x, inMin, inMax, outMin, outMax) {
    return (x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }

  static escapeXml(unsafe: string) {
    return he.encode(unsafe, {
      'strict': true
    });
  }

  static unescapeXml(str: string) {
    return he.decode(str, {
      'strict': true
    });
  }

  static extractNumber(str: string) {
    if (str && parseFloat(str)) {
      const results = /[+-]?\d+(?:\.\d+)?/g.exec(str);
      if (results && results.length > 0) {
        return Number(results[0]);
      }
    } else {
      return Number(str);
    }
    return Number.NaN;
  }

  static roughSizeOfObject(object) {

    const objectList = [];

    const recurse = (value) => {
      let bytes = 0;

      if (typeof value === 'boolean') {
        bytes = 4;
      } else if (typeof value === 'string') {
        bytes = value.length * 2;
      } else if (typeof value === 'number') {
        bytes = 8;
      } else if
      (
        typeof value === 'object'
        && objectList.indexOf(value) === -1
      ) {
        objectList[objectList.length] = value;
        for (let i in value) {
          bytes += 8; // an assumed existence overhead
          bytes += recurse(value[i]);
        }
      }

      return bytes;
    };

    return recurse(object);
  }

  /*
  static computeAngleBetween(from:LatLngLiteral, to:LatLngLiteral) {
    if (from && to) {
      return this.distanceRadians(this.toRadians(from.lat), this.toRadians(from.lng),
        this.toRadians(to.lat), this.toRadians(to.lng));
    }
    return 0;
  }
  private static toRadians(angle: number) {
    return (Math.PI / 180) * angle;
  }
  private static distanceRadians(lat1, lng1, lat2, lng2) {
    return this.arcHav(this.havDistance(lat1, lat2, lng1 - lng2));
  }
  private static arcHav(x:number){
    return 2 * Math.asin(Math.sqrt(x));
  }
  private static havDistance(lat1, lat2, dLng) {
    return this.hav(lat1 - lat2) + this.hav(dLng) * Math.cos(lat1) * Math.cos(lat2);
  }
  private static hav(x) {
    let sinHalf = Math.sin(x * 0.5);
    return sinHalf * sinHalf;
  }*/
}
